import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { ROUTES } from "../routes";


const ProtectedRoute = ({ component: Component, isAuthenticatedUser }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if(!isAuthenticatedUser) {
      navigate(ROUTES.SIGNIN, {
        state: { from: location, fromProtectedPage: true }
      });
    }
  }, [isAuthenticatedUser]);

  // Prevent the user from accidentally seeing protected stufff
  // incase the redirection from useEffect is taking long.
  return (
    isAuthenticatedUser
      ? <Component />
      : null
  );
};

export default ProtectedRoute;
